{
  "hero": {
    "subtitle": "Presencia Eterna • 24/7 en Vivo",
    "headline": "El amor es la fuerza que",
    "headlineHighlight": "une.",
    "description": "Experimenta el viaje de meditación definitivo a través de los ojos de los maestros. Un ecosistema curado para la evolución espiritual.",
    "tagline": "Maestros, prácticas en vivo, retiros, asistente de IA, calendario personal y una comunidad que apoya tu evolución. Online y offline, en cualquier parte del mundo.",
    "stat1Num": "Sesiones en vivo",
    "stat1Label": "Con maestros 24/7",
    "stat2Num": "Comunidad",
    "stat2Label": "Los tuyos, cerca",
    "stat3Num": "Eventos",
    "stat3Label": "En todo el mundo",
    "valueProp1": "Prácticas en vivo con maestros reales",
    "valueProp2": "24/7 · Siempre disponible",
    "valueProp3": "Guiado por IA, ajustado a ti",
    "startPractice": "Comenzar Práctica",
    "exploreSchedule": "Explorar Horario",
    "backLink": "← Atrás",
    "joinLiveNow": "Unirse en Vivo",
    "viewProfile": "Ver perfil →",
    "viewProfileNative": "Ver Perfil"
  },
  "agapeBanner": {
    "overline": "PRÁCTICA ABIERTA",
    "titleBefore": "La Práctica ",
    "titleHighlight": "Agapē",
    "titleAfter": "",
    "subheadline": "15 minutos para volver a ti. Quietud, claridad y un reinicio total.",
    "ctaJoin": "¡Quiero!",
    "ctaJoined": "TE ESPERAMOS",
    "inviteFriends": "Invitar amigos",
    "linkCopied": "¡Enlace copiado!",
    "shareMessage": "Únete a la Práctica Agapē este domingo"
  },
  "onboarding": {
    "focusTitle": "¿Cuál es tu enfoque?",
    "goalTitle": "¿Tu objetivo principal?",
    "timeTitle": "¿Horario preferido?",
    "focusTitleShort": "¿Enfoque?",
    "goalTitleShort": "¿Objetivo?",
    "timeTitleShort": "¿Cuándo?",
    "meditation": "Meditación",
    "yoga": "Yoga",
    "breathing": "Respiración",
    "focus": "Enfoque",
    "relaxation": "Relajación",
    "wellbeing": "Bienestar",
    "clarity": "Claridad",
    "energy": "Energía",
    "sleep": "Sueño",
    "morning": "Mañana",
    "afternoon": "Tarde",
    "evening": "Noche",
    "night": "Noche (tardía)",
    "recorded": "Grabado",
    "live": "Sesiones en vivo",
    "next": "SIGUIENTE",
    "finish": "FINALIZAR",
    "back": "ATRÁS"
  },
  "startingSoon": {
    "featuresTitleBefore": "Funciones de ",
    "featuresTitleAfter": "",
    "overline": "Practica en Comunidad",
    "title": "Sesiones en vivo ahora",
    "subtitle": "Únete a las prácticas online con nuestras mejores guías en tiempo real.",
    "joinNow": "UNIRSE AHORA",
    "joinNowBtn": "Entrar",
    "noSessions": "No hay sesiones próximas en este momento.",
    "exploreSchedule": "EXPLORAR HORARIO",
    "capabilitiesTitle": "Funciones de Agapēlla",
    "capabilitiesSubtitle": "Sin sesiones en vivo ahora — explora la plataforma",
    "capabilitiesHint": "Todo lo que necesitas para tu práctica — en un solo lugar",
    "openCard": "Abrir",
    "features": {
      "createRoomTitle": "Crea tu propia sesión en vivo",
      "createRoomTagline": "Elige una práctica, invita a tus amigos — y practica en vivo juntos",
      "findMasterTitle": "Encuentra a tu maestro",
      "findMasterTagline": "Expertos en meditación, psicología y filosofía — tu guía personal",
      "findCircleTitle": "Encuentra tu círculo",
      "findCircleTagline": "Personas afines, prácticas compartidas y eventos de la comunidad cada día",
      "talkAgapellaTitle": "Habla con Agapella",
      "talkAgapellaTagline": "El asistente IA adapta una práctica a tu estado de ánimo y crea un programa para ti",
      "calendarTitle": "Calendario de eventos",
      "calendarTagline": "Eventos online y offline por intereses. Agapella te avisa con antelación",
      "libraryTitle": "Biblioteca de prácticas",
      "libraryTagline": "Meditación, respiración, psicología, filosofía — encuentra la práctica para ti"
    }
  },
  "dailyRhythm": {
    "liveBadge": "EN VIVO",
    "liveNow": "LIVE",
    "min": "min",
    "joinNowBtn": "Entrar",
    "imGoing": "Voy a ir",
    "join": "Unirse",
    "noFilterThisDay": "No hay {{label}} este día",
    "noMatchingEvents": "No hay eventos que coincidan",
    "otherEvents": "otros eventos ↓",
    "emptyMyTitle": "No tienes eventos programados",
    "emptyTitle": "No hay eventos programados",
    "emptyMyDesc": "No tienes eventos planificados para este día.",
    "emptyDesc": "Tu agenda para este día está libre.",
    "selectFromSchedule": "Elegir del calendario",
    "title": "Tu Práctica.",
    "titleHighlight": "Cada Día.",
    "subtitle": "Planifica tu camino profundamente. Selecciona un día para ver el flujo.",
    "fullCalendar": "CALENDARIO COMPLETO",
    "allTraditions": "Todas las Tradiciones",
    "tradition": "TRADICIÓN",
    "featured": "DESTACADO",
    "agape": "AGAPÉ",
    "saveSpot": "Reserva tu lugar",
    "lives": "Sesiones en vivo",
    "events": "Eventos",
    "loading": "Cargando horario...",
    "loadFailed": "No se pudo cargar el horario",
    "noSessions": "No hay sesiones programadas para {{day}}.",
    "today": "Hoy",
    "withMaster": "con {{name}}",
    "reminderSet": "Recordatorio activado",
    "reminderRemoved": "Recordatorio eliminado",
    "reminderFailed": "Error al actualizar el recordatorio",
    "signUpNotify": "Regístrate para recibir notificaciones sobre esta sesión",
    "signUpSaveSpot": "Regístrate para reservar tu lugar en esta sesión",
    "myCalendar": "Mi calendario",
    "filters": {
      "paths": "Caminos",
      "livestreams": "En vivo",
      "livePractice": "Práctica en vivo",
      "offline": "Presencial",
      "all": "Todos",
      "selectPath": "ELIGE UN CAMINO:"
    },
    "paths": {
      "meditation": "Meditación",
      "psychology": "Psicología",
      "philosophy": "Filosofía",
      "body": "Prácticas corporales",
      "breathwork": "Respiración",
      "morning": "Práctica matutina",
      "sleep": "Antes de dormir",
      "traditions": "Tradiciones"
    },
    "formats": {
      "offline": "PRESENCIAL",
      "online": "ONLINE",
      "livestream": "EN VIVO",
      "liveroom": "PRÁCTICA EN VIVO"
    },
    "monthNames": ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
    "dayNames": ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"]
  },
  "videoBlock": {
    "overline": "El Santuario",
    "title": "Bienvenido a",
    "titleHighlight": "Agapé",
    "headlineHighlight": "une.",
    "tagline": "Una plataforma social de nuevo formato para quienes practican. Maestros, sesiones en vivo, comunidad y eventos — en un solo espacio.",
    "stat1Num": "Prácticas en vivo",
    "stat1Label": "Sesiones en vivo con maestros 24/7",
    "stat2Num": "Tu entorno",
    "stat2Label": "Una comunidad afín",
    "stat3Num": "Online y offline",
    "stat3Label": "Eventos cerca de ti",
    "description": "Agapēlla es un entorno que te impulsa hacia adelante. Encuentra maestros y personas con quienes evolucionar se vuelve natural."
  },
  "aboutPlatformWidget": {
    "title": "¿Quieres conocer las funciones de nuestra plataforma?",
    "description": "Agapēlla es un espacio para prácticas, encuentros conscientes e interacción en vivo entre maestros y participantes.",
    "cta": "Saber más"
  },
  "circlesPreview": {
    "overline": "Entorno",
    "title": "Crea tu entorno",
    "subtitle": "Únete a nuestras comunidades privadas por intereses y filosofía. Encuentra a los tuyos para crecer y evolucionar juntos.",
    "exploreAll": "Todos los círculos",
    "members": "miembros"
  },
  "communityJoin": {
    "badge": "La App del Santuario",
    "title": "Únete a la",
    "titleHighlight": "Comunidad Agapē",
    "description": "Profundiza tu práctica. Accede a meditaciones sin conexión, sigue tu progreso y conéctate con una comunidad global de buscadores.",
    "appStoreLabel": "Descárgala en",
    "appStoreName": "App Store",
    "playStoreLabel": "DISPONIBLE EN",
    "playStoreName": "Google Play",
    "rating": "4.9/5 de más de 2,000 miembros"
  },
  "communityFeed": {
    "sectionLabel": "Comunidad",
    "postsFrom": "Publicaciones del Maestro",
    "you": "Tú",
    "pinned": "Fijado por el maestro",
    "firstComment": "Sé el primero en comentar",
    "addComment": "Agrega un comentario...",
    "sharePlaceholder": "Comparte algo con tu comunidad...",
    "newPost": "Nueva Publicación",
    "whatOnMind": "¿Qué tienes en mente?",
    "audienceLabel": "Audiencia",
    "audiencePublic": "Para todos",
    "audienceSubscribers": "Para suscriptores",
    "postLockedTitle": "Esta publicación es para los suscriptores del maestro",
    "postLockedBody": "Suscríbete a {{name}} para leerla",
    "postLockedMaster": "el maestro",
    "postLockedCta": "Suscribirse al maestro",
    "postLockedSignIn": "Inicia sesión para suscribirte al maestro y leer la publicación.",
    "postGone": "La publicación no está disponible: fue eliminada u oculta.",
    "postLoadFailed": "No se pudo abrir la publicación.",
    "noPostsGuest": "Aún no hay publicaciones",
    "noPostsOwner": "Aún no hay publicaciones — ¡comparte tu primera publicación arriba!",
    "post": "PUBLICAR",
    "addPhoto": "Añadir foto",
    "addVideo": "Añadir vídeo",
    "photoAttached": "Foto adjunta",
    "removePhoto": "Quitar foto",
    "photoLabel": "Foto",
    "videoLabel": "Vídeo",
    "uploadingVideo": "Subiendo… {{percent}}%",
    "processingVideo": "Procesando vídeo…",
    "currentVideo": "Vídeo actual",
    "tooManyPhotos": "Puedes adjuntar como máximo {{count}} fotos a una publicación",
    "photosOrVideo": "Una publicación puede llevar fotos o un vídeo, pero no ambos",
    "eventChip": "EVENTO",
    "onlineAnnouncementChip": "Anuncio de sesión en línea",
    "offlineEventChip": "Evento presencial",
    "practiceChip": "PRÁCTICA",
    "goTo": "Abrir",
    "join": "Unirse",
    "joined": "Asistiré",
    "pin": "Fijar",
    "unpin": "Desfijar",
    "delete": "Eliminar",
    "deleteConfirmTitle": "¿Eliminar la publicación?",
    "deleteConfirmBody": "Desaparecerá para todos los miembros de la comunidad. Esta acción no se puede deshacer.",
    "deleteConfirmBodyDiscussion": "La publicación y su debate desaparecerán para todos los participantes, junto con los mensajes. Esta acción no se puede deshacer.",
    "edit": "Editar",
    "edited": "Editado",
    "readMore": "Leer más",
    "close": "Cerrar",
    "save": "Guardar",
    "cancel": "Cancelar",
    "manageMenu": "Acciones de la publicación",
    "share": "Compartir",
    "loadFailed": "No se pudo cargar el feed",
    "retry": "Reintentar"
  },
  "theSpace": {
    "overline": "La Experiencia",
    "title": "El Espacio",
    "description": "Diseñado para la vida moderna. Únete a sesiones cortas y guiadas por maestros en meditación, psicología y respiración.",
    "liveStreams": "Sesiones en Vivo",
    "liveStreamsSubtitle": "Práctica en vivo, ahora mismo.",
    "liveStreamsDesc": "Únete a sesiones que están ocurriendo ahora o que comienzan pronto — guiadas en tiempo real por maestros de clase mundial.",
    "liveStreamsBadge": "Siempre Activo · 24/7",
    "liveStreamsAction": "Unirse en vivo",
    "aiCompanion": "Compañero IA",
    "aiCompanionSubtitle": "Guía privada, en cualquier momento.",
    "aiCompanionDesc": "Conversa, establece una intención y encuentra la práctica adecuada para tu estado mental.",
    "aiCompanionBadge": "Privado · Bajo Demanda",
    "aiCompanionAction": "Iniciar conversación",
    "agapePractices": "PRÁCTICAS AGAPĒ",
    "agapePracticesSubtitle": "Curadas por Agapē.",
    "agapePracticesDesc": "Sesiones aprobadas por Agapē en meditación, enfoque, equilibrio, gratitud y trabajo del corazón.",
    "agapePracticesBadge": "Curado · Aprobado por Agapē",
    "agapePracticesAction": "Explorar prácticas",
    "communities": "Comunidades",
    "communitiesSubtitle": "Crece con tu gente.",
    "communitiesDesc": "Únete a grupos basados en intenciones para mantenerte conectado y constante entre sesiones.",
    "communitiesBadge": "Comunidad · Orientado a Miembros",
    "communitiesAction": "Descubrir comunidades"
  },
  "practices": {
    "title": "Prácticas",
    "subtitle": "Elige lo que necesitas: enfoque, paz, amor o fortaleza interior.",
    "exploreLibrary": "Explorar Biblioteca Completa",
    "allPractices": "Todas las Prácticas",
    "meditation": "Meditación",
    "breathwork": "Respiración",
    "movement": "Movimiento",
    "meditative": "Prácticas Meditativas",
    "meditativeDesc": "Presencia, silencio, espaciosidad interior para conectar con tu energía.",
    "meditativeTag1": "Calma Profunda",
    "meditativeTag2": "Conciencia Abierta",
    "meditativeBadge": "Meditativo",
    "neurofocus": "Neuroenfoque",
    "neurofocusDesc": "Atención, hábitos y claridad mental para el trabajo profundo.",
    "neurofocusTag1": "Reset de 90 Seg",
    "neurofocusTag2": "Estado de Flujo",
    "neurofocusBadge": "Tendencia",
    "stateDesign": "Diseño de Estado",
    "stateDesignDesc": "Establece conscientemente tu tono emocional y energético.",
    "stateDesignTag": "Alineación Matutina",
    "stateDesignBadge": "Diseño",
    "somaticBreathwork": "Respiración Somática",
    "somaticBreathworkDesc": "Usando la respiración para liberar la tensión almacenada en el cuerpo.",
    "somaticBreathworkTag1": "Liberación",
    "somaticBreathworkTag2": "Energía",
    "somaticBreathworkBadge": "Cuerpo",
    "sleepNonDoing": "Sueño y No-Hacer",
    "sleepNonDoingDesc": "Prácticas para el descanso profundo, conciliar el sueño y soltar.",
    "sleepNonDoingTag1": "NSDR",
    "sleepNonDoingTag2": "Yoga Nidra",
    "sleepNonDoingBadge": "Descanso",
    "communityCircles": "Círculos Comunitarios",
    "communityCirclesDesc": "Indagación compartida y sostener un espacio para los demás.",
    "communityCirclesTag": "Relacional",
    "communityCirclesBadge": "Compartido"
  },
  "masters": {
    "overline": "Guías del Santuario",
    "title": "Humanos Reales.",
    "titleHighlight": "Práctica Real.",
    "description": "Experimenta la sabiduría combinada de guías de clase mundial en meditación, respiración y crecimiento espiritual.",
    "exploreAll": "Explorar Todos los Maestros",
    "masterBadge": "MAESTRO",
    "fallbackDesc": "Maestro"
  },
  "schedule": {
    "title": "Tu Práctica.",
    "titleHighlight": "Cada Día.",
    "subtitle": "Planifica tu camino profundamente. Selecciona un día para ver el flujo.",
    "today": "Hoy",
    "withMaster": "con {{name}}",
    "upcomingIntensive": "INTENSIVO PRÓXIMO"
  },
  "scheduleCalendar": {
    "eventsThisMonth": "{{count}} evento este mes",
    "eventsThisMonth_plural": "{{count}} eventos este mes",
    "selectDate": "Selecciona una Fecha",
    "eventCount": "{{count}} evento",
    "eventCount_plural": "{{count}} eventos",
    "noEvents": "No hay eventos programados",
    "noEventsHint": "Selecciona otra fecha o explora un mes diferente",
    "reminded": "Recordatorio activo",
    "remindMe": "Recordarme"
  },
  "native": {
    "tabs": {
      "home": "Inicio",
      "events": "Eventos",
      "practices": "Prácticas",
      "masterFeed": "Feed del\nmaestro",
      "liveSession": "Sesión\nen vivo",
      "messages": "Mensajes",
      "profile": "Perfil"
    },
    "heroFallback": {
      "title": "Una plataforma social\nque une a las personas\nen el camino del desarrollo.",
      "subtitle": "Maestros, prácticas en vivo, retiros, asistente de IA, calendario personal y un entorno que apoya tu evolución. Online y presencial, en cualquier lugar del mundo."
    },
    "heroArt": {
      "dark": "Atardecer sobre un lago, montañas",
      "light": "Amanecer sobre un lago, montañas"
    },
    "closing": {
      "lead": "Tu práctica. ",
      "accent": "Cada día."
    },
    "openPractice": {
      "label": "PRÁCTICA ABIERTA",
      "title": "Práctica Agapē",
      "description": "15 minutos que te devuelven a ti. Silencio, claridad y un reinicio total.",
      "want": "Quiero",
      "invite": "Invitar amigos"
    },
    "capabilitiesLead": "Posibilidades de ",
    "capabilities": {
      "createRoom": {
        "title": "Crea\ntu sesión en vivo",
        "description": "Elige una práctica, invita a tus amigos y practicad juntos en tiempo real."
      },
      "masters": {
        "title": "Encuentra\na tu maestro",
        "description": "Expertos en meditación y psicología — tu guía personal."
      },
      "calendar": {
        "title": "Calendario\nde prácticas",
        "description": "Eventos online y presenciales cada día."
      },
      "assistant": {
        "title": "Asistente de IA",
        "description": "Una compañía cálida en cualquier momento del día."
      },
      "library": {
        "title": "Tu\nbiblioteca",
        "description": "Prácticas favoritas y grabaciones a mano."
      },
      "center": {
        "title": "Centro\nAgapē",
        "description": "Un entorno que apoya tu evolución."
      }
    },
    "sections": {
      "capabilities": "Posibilidades",
      "liveNow": "Sesiones en vivo ahora",
      "upcomingEvents": "Próximos eventos",
      "featuredMasters": "Maestros cerca",
      "upcomingFallback": "Próximos eventos",
      "newMedia": "Nuevos medios"
    },
    "seeAll": "VER TODO",
    "join": "Unirse",
    "audio": "Audio",
    "online": "Online",
    "offline": "Presencial",
    "calendarChips": {
      "directions": "Direcciones",
      "live": "Sesión en vivo",
      "offline": "Presencial"
    },
    "inviteMessage": "Únete a una práctica en Agapella — 15 minutos de silencio que te devuelven a ti."
  }
}
